module.exports = __webpack_public_path__ + "img/Rebatecoupon.07e0ab42.png";